(function () {
  'use strict';

  var state = { searchTimer: null, reviewIndex: 0 };
  var routes = window.milnest && window.milnest.routes ? window.milnest.routes : {};

  function qs(selector, root) { return (root || document).querySelector(selector); }
  function qsa(selector, root) { return Array.prototype.slice.call((root || document).querySelectorAll(selector)); }
  function htmlEscape(value) {
    return String(value == null ? '' : value).replace(/[&<>'"]/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[character];
    });
  }
  function formatMoney(cents) {
    var amount = (Number(cents || 0) / 100).toFixed(2);
    var format = (window.milnest && window.milnest.moneyFormat) || '₹{{amount}}';
    var plain = amount.replace(/\.00$/, '');
    return format.replace(/{{amount_no_decimals}}/g, plain).replace(/{{amount}}/g, amount).replace(/{{amount_with_comma_separator}}/g, amount.replace('.', ','));
  }
  function showToast(message) {
    var toast = qs('#milnestToast');
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('show');
    window.clearTimeout(showToast.timer);
    showToast.timer = window.setTimeout(function () { toast.classList.remove('show'); }, 3200);
  }
  function setLayer(id, open) {
    var layer = document.getElementById(id);
    if (!layer) return;
    layer.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (open) {
      var focusTarget = qs('input, button', layer);
      if (focusTarget) window.setTimeout(function () { focusTarget.focus(); }, 80);
    }
  }
  function closeLayers() { setLayer('searchDrawer', false); setLayer('cartDrawer', false); }

  function renderShipping(total) {
    var target = qs('[data-shipping-progress]');
    if (!target) return;
    var threshold = Number(window.milnest && window.milnest.freeShippingThreshold || 99900);
    var current = Number(total || 0);
    var progress = Math.min(100, threshold ? (current / threshold) * 100 : 100);
    var message = current >= threshold ? 'You unlocked free shipping.' : 'You are ' + formatMoney(threshold - current) + ' away from free shipping.';
    target.innerHTML = '<span>' + message + '</span><div class="progress-track"><div class="progress-fill" style="width:' + progress + '%"></div></div>';
  }

  function renderCart(cart) {
    qsa('[data-cart-count]').forEach(function (node) { node.textContent = cart.item_count; });
    qsa('[data-cart-total]').forEach(function (node) { node.textContent = formatMoney(cart.total_price); });
    renderShipping(cart.total_price);
    qsa('[data-cart-items]').forEach(function (container) {
      if (!cart.items || !cart.items.length) {
        container.innerHTML = '<p class="empty-state">Your bag is waiting for a little millet goodness.</p>';
        return;
      }
      container.innerHTML = cart.items.map(function (item, index) {
        var image = item.image ? '<img src="' + htmlEscape(item.image) + '" alt="' + htmlEscape(item.product_title) + '" loading="lazy">' : '<span class="tiny-pack">MILNEST</span>';
        var variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : 'Everyday pack';
        return '<div class="cart-line" data-cart-line="' + (index + 1) + '">' +
          '<a class="cart-line-visual" href="' + htmlEscape(item.url) + '" aria-label="View ' + htmlEscape(item.product_title) + '">' + image + '</a>' +
          '<div><h4>' + htmlEscape(item.product_title) + '</h4><p>' + htmlEscape(variant) + '</p><button class="remove-link" type="button" data-cart-remove data-line="' + (index + 1) + '">Remove</button></div>' +
          '<div class="cart-line-right"><strong>' + formatMoney(item.final_line_price) + '</strong><div class="quantity" aria-label="Quantity for ' + htmlEscape(item.product_title) + '"><button type="button" data-cart-decrease data-line="' + (index + 1) + '" aria-label="Decrease quantity">−</button><span>' + item.quantity + '</span><button type="button" data-cart-increase data-line="' + (index + 1) + '" aria-label="Increase quantity">+</button></div></div>' +
          '<input class="cart-line-quantity" type="hidden" name="updates[]" value="' + item.quantity + '" data-cart-quantity data-line="' + (index + 1) + '">' +
          '</div>';
      }).join('');
    });
  }

  function cartUrl(path, suffix) {
    var base = path || '/cart';
    return base.replace(/\/$/, '') + (suffix || '');
  }
  function refreshCart(openAfter) {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (response) { if (!response.ok) throw new Error('Cart unavailable'); return response.json(); })
      .then(function (cart) { renderCart(cart); if (openAfter) setLayer('cartDrawer', true); return cart; });
  }
  function changeCart(line, quantity) {
    var endpoint = cartUrl(routes.cartChange || '/cart/change', '.js');
    return fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ line: Number(line), quantity: Math.max(0, Number(quantity)) }) })
      .then(function (response) { if (!response.ok) throw new Error('Could not update bag'); return response.json(); })
      .then(function (cart) { renderCart(cart); return cart; })
      .catch(function () { showToast('We could not update the bag. Please try again.'); });
  }

  function searchSuggestions(query) {
    var results = qs('[data-search-results]');
    if (!results || !query) return;
    window.clearTimeout(state.searchTimer);
    state.searchTimer = window.setTimeout(function () {
      fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6')
        .then(function (response) { if (!response.ok) throw new Error('Search unavailable'); return response.json(); })
        .then(function (data) {
          var products = data.resources && data.resources.results && data.resources.results.products ? data.resources.results.products : [];
          if (!products.length) { results.innerHTML = '<p class="search-prompt">No exact match yet — try another flavour or browse the collection.</p>'; return; }
          results.innerHTML = products.map(function (product) { return '<a class="search-result" href="' + htmlEscape(product.url) + '"><span>' + htmlEscape(product.title) + '</span><small>View ↗</small></a>'; }).join('');
        })
        .catch(function () { results.innerHTML = '<p class="search-prompt">Press enter to see all search results.</p>'; });
    }, 220);
  }

  function updateReviews(direction) {
    var track = qs('[data-review-track]');
    if (!track) return;
    var cards = qsa('.review-card', track);
    if (cards.length < 2) return;
    var mobile = window.matchMedia && window.matchMedia('(max-width: 760px)').matches;
    var visible = mobile ? 1 : 3;
    var max = Math.max(0, cards.length - visible);
    state.reviewIndex = Math.max(0, Math.min(max, state.reviewIndex + direction));
    if (mobile) {
      var cardWidth = cards[0].getBoundingClientRect().width;
      track.style.transform = 'translateX(-' + (state.reviewIndex * (cardWidth + 10)) + 'px)';
    } else {
      track.style.transform = 'none';
    }
  }

  document.addEventListener('click', function (event) {
    var openSearch = event.target.closest('[data-open-search]');
    var openCart = event.target.closest('[data-open-cart]');
    if (openSearch) { event.preventDefault(); closeLayers(); setLayer('searchDrawer', true); }
    if (openCart) { event.preventDefault(); closeLayers(); setLayer('cartDrawer', true); }
    if (event.target.closest('[data-close-search]')) setLayer('searchDrawer', false);
    if (event.target.closest('[data-close-cart]')) setLayer('cartDrawer', false);
    var increase = event.target.closest('[data-cart-increase]');
    var decrease = event.target.closest('[data-cart-decrease]');
    var remove = event.target.closest('[data-cart-remove]');
    if (increase || decrease || remove) {
      event.preventDefault();
      var control = increase || decrease || remove;
      var line = control.getAttribute('data-line');
      var row = control.closest('.cart-line');
      var quantityNode = row && qs('.quantity span', row);
      var current = quantityNode ? Number(quantityNode.textContent) : 1;
      changeCart(line, remove ? 0 : current + (increase ? 1 : -1));
    }
    if (event.target.closest('[data-review-prev]')) updateReviews(-1);
    if (event.target.closest('[data-review-next]')) updateReviews(1);
    if (event.target.closest('[data-close-layer]')) closeLayers();
  });

  document.addEventListener('keydown', function (event) { if (event.key === 'Escape') closeLayers(); });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[action*="/cart/add"]');
    if (!form || form.closest('#MainCartForm')) return;
    event.preventDefault();
    var button = qs('[type="submit"]', form);
    if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
    fetch(cartUrl(routes.cartAdd || '/cart/add', '.js'), { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
      .then(function (response) { if (!response.ok) throw new Error('Could not add'); return response.json(); })
      .then(function () { showToast('Added to your MILNEST bag.'); return refreshCart(true); })
      .catch(function () { showToast('Please try adding that again.'); })
      .finally(function () { if (button) { button.disabled = false; button.removeAttribute('aria-busy'); } });
  });

  document.addEventListener('input', function (event) { if (event.target.matches('[data-search-input]')) searchSuggestions(event.target.value.trim()); });

  document.addEventListener('DOMContentLoaded', function () {
    var menuButton = qs('#menuButton');
    var mobileMenu = qs('#mobileMenu');
    if (menuButton && mobileMenu) {
      menuButton.addEventListener('click', function () {
        var open = mobileMenu.getAttribute('aria-hidden') === 'false';
        mobileMenu.setAttribute('aria-hidden', open ? 'true' : 'false');
        menuButton.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    }
    renderShipping(window.milnest && window.milnest.cartTotalPrice);
    updateReviews(0);
  });
}());
